import { render, staticRenderFns } from "./Bbdc.vue?vue&type=template&id=151f58ad&scoped=true&"
import script from "./Bbdc.vue?vue&type=script&lang=js&"
export * from "./Bbdc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151f58ad",
  null
  
)

export default component.exports